export const downloadFile = async (downloadPath: string, options: Options) => {
  const { accessToken, retries = 3, signal, ssoApiUrl } = options;

  let err: unknown;
  let dlk: string | undefined;

  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await fetch(`${ssoApiUrl}/api/oauth/stk`, {
        signal,
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
        },
      });

      ({ dlk } = (await response.json()) as STKResponse);
      break;
    } catch (e) {
      err = e;
    }
  }

  if (dlk == null) {
    console.error(err);
    throw new Error("Could not get file STK", { cause: err });
  }

  const href = new URL(downloadPath);
  href.searchParams.set("dlk", dlk);

  window.location.href = href.toString();
};

export interface STKResponse {
  dlk: string;
  /** In seconds */
  expires_in: number;
}

interface Options {
  ssoApiUrl: string;
  accessToken: string;
  signal: AbortSignal;
  retries?: number;
}
